export const CONTENT_SELECTOR_OPTIONS = [
	{
		label: 'Select Visible Columns',
		options: [
			{ id: 'applicationName', label: 'Application Name', visible: true },
			{ id: 'description', label: 'Description', visible: true },
			{ id: 'domain', label: 'Domain', visible: true },
			{ id: 'actions', label: 'Actions', visible: true },
		],
	},
];

export const PAGE_SELECTOR_OPTIONS = [
	{ value: 10, label: '10 Applications' },
	{ value: 30, label: '30 Applications' },
	{ value: 50, label: '50 Applications' },
];

export const COLLECTION_PREFERENCES = {
	title: 'Preferences',
	confirmLabel: 'Confirm',
	cancelLabel: 'Cancel',
	pageSizePreference: {
		title: 'Select page size',
		options: PAGE_SELECTOR_OPTIONS,
	},
	visibleContentPreference: {
		title: 'Select visible content',
		options: CONTENT_SELECTOR_OPTIONS,
	},
};

export const DEFAULT_PREFERENCES = {
	pageSize: 10,
	visibleContent: [
		'applicationName',
		'description',
		'domain',
		'actions',
	],
};


